// extracted by mini-css-extract-plugin
export default {"currentDate":"CurrentDate_currentDate__oq-Fi"};